/**
 * Utilities for document color coding
 */

/**
 * Generates a consistent color based on a document name
 * @param {string} name - The document name to generate a color from
 * @returns {string} A CSS color value (HSL format)
 */
export function generateDocumentColor(name) {
  // Simple hash function to generate a number from a string
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Convert to a hex color with fixed hue ranges for better readability
  const hue = Math.abs(hash % 360);
  const saturation = 70; // Fixed saturation
  const lightness = 60; // Fixed lightness for better readability
  
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

/**
 * Gets a text color (black or white) to ensure contrast with a background color
 * @param {string} backgroundColor - The background color (can be hex, rgb, or hsl)
 * @returns {string} A text color ('black' or 'white')
 */
export function getContrastColor(backgroundColor) {
  // For HSL colors, we can simply use the lightness value
  if (backgroundColor.startsWith('hsl')) {
    const match = backgroundColor.match(/hsl\(\d+,\s*\d+%,\s*(\d+)%\)/);
    if (match && match[1]) {
      const lightness = parseInt(match[1], 10);
      return lightness > 50 ? 'black' : 'white';
    }
  }
  
  // Default to black if we can't determine
  return 'black';
}
